import React from "react"

import { useAudioSignedUrlTransport } from "@/audio"

import MiniAudioPlayer from "@/components/audio-player/MiniAudioPlayer"

import type { EditableTestCase } from "../../../model"
import { InputCellWrapper } from "./InputCellWrapper"

interface AudioInputCellProps {
  testCase: EditableTestCase
  isExpanded: boolean
  width: string
}

/** Displays an audio test case with an inline player. Fetches a signed URL for the S3 audio file. */
export const AudioInputCell: React.FC<AudioInputCellProps> = ({
  testCase,
  isExpanded,
  width,
}) => {
  const { data: audioUrl, isError } = useAudioSignedUrlTransport(
    {
      bucket: testCase.s3_bucket || "",
      audioKey: testCase.s3_key || "",
      asTestCase: true,
    },
    { enabled: !!testCase.s3_key && !!testCase.s3_bucket },
  )

  return (
    <InputCellWrapper
      width={width}
      isExpanded={isExpanded}
      ariaLabel="Play audio test case"
    >
      <div className="flex items-center gap-2">
        {isError ? (
          <span className="text-xs text-coval-danger-text">
            Failed to load audio
          </span>
        ) : audioUrl ? (
          <MiniAudioPlayer audioUrl={audioUrl} />
        ) : (
          <span className="text-xs text-coval-text-muted">
            Loading audio...
          </span>
        )}
        <span className="text-sm text-coval-text-muted truncate">
          {testCase.input_str || "Audio test case"}
        </span>
      </div>
    </InputCellWrapper>
  )
}
